import { render, staticRenderFns } from "./EnacCustomAtplAssessmentEditTopBox.vue?vue&type=template&id=60a38db0"
import script from "./EnacCustomAtplAssessmentEditTopBox.vue?vue&type=script&lang=js"
export * from "./EnacCustomAtplAssessmentEditTopBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports